import React, { Component } from "react"
import Dropdown from "react-bootstrap/lib/Dropdown"
import DropdownToggle from "react-bootstrap/lib/DropdownToggle"
import MenuItem from "react-bootstrap/lib/MenuItem"
import TeamSigil from "./team_sigil"
import peopleOutline from "../images/people-outline.svg"

class DashboardSelector extends Component {
    constructor(props) {
        super(props)

        this.renderMenuItem = this.renderMenuItem.bind(this)
        this.isTeamAdmin = this.isTeamAdmin.bind(this)
    }

    isPersonalTeam = team => {
        const { personalTeamId } = this.props
        return !team || team.id === personalTeamId
    }

    isTeamAdmin(teamId) {
        const { profile } = this.props
        const membership = Object.keys(profile.memberships)
            .map(k => profile.memberships[k])
            .find(m => m.teamId === teamId)
        return membership && membership.accessLevel === "Admin"
    }

    doSelect = team => {
        if (team === "__NEW_TEAM__") {
            this.props.editTeam("")
            return
        }
        this.props.onChange(team.id)
    }

    renderCreateTeam = () => {
        return (
            <button
                className="btn btn-default create-team-btn"
                onClick={() => this.props.editTeam("")}
            >
                <img src={peopleOutline} alt="icon for people" />
                Create Team
            </button>
        )
    }

    renderSelection = () => {
        const { teams, selectedTeamId } = this.props
        const team = teams.find(t => t.id === selectedTeamId)
        const isPersonalTeamSelected = this.isPersonalTeam(team)

        return (
            <span>
                {this.renderTeamSigil(team)}
                {isPersonalTeamSelected ? "Personal" : team.name}
            </span>
        )
    }

    renderTeamSigil = team => {
        if (!team) {
            return undefined
        }
        return TeamSigil(team)
    }

    renderMenuItem = team => {
        if (!team) {
            return undefined
        }

        return (
            <MenuItem
                key={team.id}
                eventKey={team}
                className="cog-icon-container"
            >
                <span>
                    {this.renderTeamSigil(team)}
                    {team.name}
                </span>
                {this.isTeamAdmin(team.id) && (
                    <span onClick={() => this.props.editTeam(team.id)}>
                        <i className="fa fa-cog fa-lg" />
                    </span>
                )}
            </MenuItem>
        )
    }

    render() {
        const { personalTeam, otherTeams } = this.props

        return otherTeams.length === 0 ? (
            this.renderCreateTeam()
        ) : (
            <Dropdown
                id="teams-dropdown"
                className="btn-group"
                onSelect={this.doSelect}
            >
                <DropdownToggle className="btn-team btn-team-desktop" noCaret>
                    {this.renderSelection()}
                    <i className="fa fa-team-menu-icon" aria-hidden="true" />
                </DropdownToggle>
                <Dropdown.Menu className="dropdown-scroller">
                    {personalTeam && (
                        <MenuItem key={personalTeam.id} eventKey={personalTeam}>
                            <img src={personalTeam.logoUrl} alt="" />
                            Personal
                        </MenuItem>
                    )}
                    {otherTeams
                        .sort((a, b) =>
                            a.name === b.name ? 0 : a.name > b.name ? 1 : -1,
                        )
                        .map(team => this.renderMenuItem(team))}
                    <li role="separator" className="divider" />
                    <MenuItem key={"__NEW_TEAM__"} eventKey={"__NEW_TEAM__"}>
                        New Team
                    </MenuItem>
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}

export default DashboardSelector



// WEBPACK FOOTER //
// ./src/components/dashboard_selector.jsx